import envConfig from '../../db-env-build';
import { EBANKINGWEBLUX, RM_REGION } from '../constants';
import { PAYMENT_TYPE } from '../muster/app/payments/constant';

// check if verification of payee (VoP) feature is enabled, selected region is LUX and payment type is SEPA
export function isVopAllowed(isVopEnabled, paymentType) {
  return (
    isVopEnabled &&
    (envConfig.envConfig === EBANKINGWEBLUX || envConfig.rmRegion === RM_REGION) &&
    paymentType === PAYMENT_TYPE.SEPA
  );
}